import script from "./ThePromo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThePromo.vue?vue&type=script&setup=true&lang=ts"

import "./ThePromo.vue?vue&type=style&index=0&id=4328df8e&lang=scss"

const __exports__ = script;

export default __exports__